import { render, staticRenderFns } from "./DeleteAuth0AccountModal.vue?vue&type=template&id=4e447860&scoped=true"
import script from "./DeleteAuth0AccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAuth0AccountModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAuth0AccountModal.vue?vue&type=style&index=0&id=4e447860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e447860",
  null
  
)

export default component.exports